import React, { useEffect, useState } from "react";
import { fetchStatsData } from "../../pages/landing-page/api-handlers";
import routes from "../../config/routes-config";
import about_svg from "../../assets/images/about_office.svg";

const About = () => {
  const [statsData, setStatsData] = useState({
    totalNumberOfProjects: 0,
    totalNumberOfTeacher: 0,
    totalNumberOfStudent: 0,
  });

  useEffect(() => {
    fetchStatsData(routes.landingPage.statsUrl, setStatsData);
  }, []);

  return (
    <div className="h-screen flex flex-col justify-center">
      {statsData && (
        <div className="lg:mt-20 md:mt-20 mt-20 mb-2 p-10 relative sm:flex items-center justify-evenly">
          <div className="item xl:p-6 p-4 sm:w-1/5 w-full bg-[#f4f4ff] shadow-lg">
            <h2 className="text-center text-2xl font-normal m-2">
              Total Projects
            </h2>
            <h2 className="text-center text-3xl font-semibold m-1">
              {statsData.totalNumberOfProjects}
            </h2>
          </div>
          <div className="item xl:p-6 p-4 sm:w-1/5 w-full bg-[#f4f4ff] shadow-lg">
            <h2 className="text-center text-2xl font-normal m-2">
              Total Students
            </h2>
            <h2 className="text-center text-3xl font-semibold m-1">
              {statsData.totalNumberOfStudent}
            </h2>
          </div>
          <div className="item xl:p-6 p-4 sm:w-1/5 w-full bg-[#f4f4ff] shadow-lg">
            <h2 className="text-center text-2xl font-normal m-2">
              Total Teachers
            </h2>
            <h2 className="text-center text-3xl font-semibold m-1">
              {statsData.totalNumberOfTeacher}
            </h2>
          </div>
        </div>
      )}
      <div className="flex justify-center items-center h-96 w-auto relative mt-6">
        <div className="w-1/2 flex flex-row items-center justify-around ">
          <img
            src={about_svg}
            alt="working"
            className="lg:ml-60 md:ml-40 ml-32 h-60"
          />
        </div>
        <div className="sm:w-1/2 w-2/3 flex flex-col items-end px-10 xl:mr-72 lg:mr-44 md:mr-24 mr-16 h-60">
          <h1 className="lg:text-4xl text-3xl text-[#0F0F10] font-medium ml-[-10.25rem] mb-8">
            Project Hub
          </h1>
          <div className="border-r-4 border-[gray] border-solid w-4/5 ">
            <h1 className="xl:mx-10 mx-8 text-right xl:text-lg lg:text-base md:text-sm text-xs">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ullam
              quo aperiam nostrum. At consequuntur quos, ipsum quo officia
              facere molestiae?
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
